import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function MarriageCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("marriageCard.title")}</h1>
      <p>{t("marriageCard.intro")}</p>

      <CodeBlock title="marriageImage()">{`import { marriageImage } from "kira-arts";

const buffer = await marriageImage(leftUserId, rightUserId, {
  guildId,
  useRoleColor: true,
  marriedSince: "2024-02-14",
  vows: "Together through every update and every bug fix.",
});`}</CodeBlock>

      <h2>{t("marriageCard.optionsTitle")}</h2>
      <CodeBlock title="MarriageOptions">{`leftImage?: string;
rightImage?: string;
marriedSince?: Date | string;
vows?: string;
accentColor?: string;
borderColor?: ColorInput;
removeBorder?: boolean;
useNitroTheme?: boolean;
useRoleColor?: boolean;
customBackground?: string;
localDateType?: string;
guildId?: string;
bypassCache?: boolean;
theme?: KiraThemeName;`}</CodeBlock>

      <p>
        <Trans i18nKey="marriageCard.daysNote" components={[<code key="0" />, <code key="1" />]} />
      </p>

      <p>
        <Trans i18nKey="marriageCard.vowsNote" components={[<code key="0" />]} />
      </p>
    </article>
  );
}
